"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContributionRegistry = void 0;
const rxjs_1 = require("rxjs");
const Log_1 = __importDefault(require("../Log"));
const agent_1 = require("../agent");
const StreamContribution_1 = require("./StreamContribution");
class ContributionRegistry {
    constructor(platform) {
        this.contributionsIds = [];
        this.SupportedContributionTypeMap = new Map([
            [
                'WEBRTC_UNREAL_STREAM',
                (id, owner, version, description) => {
                    return new StreamContribution_1.StreamContribution(id, this.platform.agent, owner, version, description);
                }
            ]
        ]);
        this.platform = platform;
    }
    close() {
        if (this.contributionPullInterval) {
            clearInterval(this.contributionPullInterval);
        }
    }
    listen(key) {
        const contributions = new Map();
        return new rxjs_1.Observable((subscriber) => {
            // AppSync might fail to trigger a subscription event. This is just a fail safe
            // in case we have a contribution and was not tirggered on subscription
            this.contributionPullInterval = setInterval(() => {
                // Notify existing
                this.platform.agent.getContributions(key).then((existingContributions) => {
                    existingContributions.forEach((c) => {
                        const { launchRequestId, modelId, ueVersion } = JSON.parse(c.data);
                        const contribution = this.SupportedContributionTypeMap.get(key)(c.id, new agent_1.RemoteAgent(c.agentId), 'cirrus-4.25', { launchRequestId, modelId, ueVersion: ueVersion });
                        contributions.set(c.id, contribution);
                        //Only send updates once
                        if (this.contributionsIds.indexOf(c.id) < 0) {
                            this.contributionsIds.push(c.id);
                            subscriber.next({ id: c.id, type: agent_1.ContributionTypes.CONTRIBUTION, contribution });
                        }
                    });
                });
            }, 5000);
            // Listen for updates
            this.platform.agent.subscribeToContributions(key, (event) => {
                if (event.contribution === agent_1.ContributionTypes.CONTRIBUTION) {
                    // TODO: streaming-agent reactor
                    // const streamData: {
                    //   id: string;
                    //   owner: IRemoteAgent;
                    //   version: string;
                    //   description: { modelName: string; modelId?: string; launchRequestId?: string };
                    // } = JSON.parse(event.data);
                    const { launchRequestId, modelId, ueVersion } = JSON.parse(event.data);
                    const contribution = this.SupportedContributionTypeMap.get(key)(event.id, new agent_1.RemoteAgent(event.agentId), 'cirrus-4.25', { launchRequestId, modelId, ueVersion: ueVersion });
                    // Only send updates once
                    if (this.contributionsIds.indexOf(event.id) < 0) {
                        this.contributionsIds.push(event.id);
                        contributions.set(event.id, contribution);
                        Log_1.default.info(`sending to subscriber ${JSON.stringify(contribution.description)}`);
                        subscriber.next({ id: event.id, type: agent_1.ContributionTypes.CONTRIBUTION, contribution });
                    }
                }
                else if (event.contribution === agent_1.ContributionTypes.WITHDRAWAL) {
                    Log_1.default.info('contribution withdrawn: ' + JSON.stringify(event));
                    const contribution = contributions.get(event.id);
                    subscriber.next({ id: event.id, type: agent_1.ContributionTypes.WITHDRAWAL, contribution });
                }
            });
        });
    }
}
exports.ContributionRegistry = ContributionRegistry;
